import { DialogActions, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Actions = styled(DialogActions)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "30px",
  textAlign: "center",
  padding: "20px",
});

export const SaveButton = styled(Button)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});
